/*
TOUCHBeauty Multi Store Region Selector
Dawn 15.5 Compatible
*/


(function () {


  function initRegionSelector() {


    const selector = document.querySelector(
      "[data-tb-region-selector]"
    );


    if (!selector) return;



    const button = selector.querySelector(
      ".tb-region-selector__button"
    );


    const menu = selector.querySelector(
      ".tb-region-selector__menu"
    );


    if (!button || !menu) return;



    /*
    Open / Close Dropdown
    */


    button.addEventListener(
      "click",
      function (event) {


        event.preventDefault();

        event.stopPropagation();


        const isOpen =
          button.getAttribute(
            "aria-expanded"
          ) === "true";



        button.setAttribute(
          "aria-expanded",
          String(!isOpen)
        );


        menu.hidden = isOpen;



      }
    );




    /*
    Close When Click Outside
    */


    document.addEventListener(
      "click",
      function(event){


        if(
          !selector.contains(
            event.target
          )
        ){

          button.setAttribute(
            "aria-expanded",
            "false"
          );


          menu.hidden = true;


        }


      }
    );





    /*
    Region Switching
    Keep:
    - pathname
    - query string
    - UTM parameters
    */


    const regionLinks =
      selector.querySelectorAll(
        ".tb-region-item"
      );



    regionLinks.forEach(
      function(link){


        link.addEventListener(
          "click",
          function(event){


            event.preventDefault();



            const target =
              link.getAttribute(
                "href"
              );



            window.location.href =
              target;



          }
        );


      }
    );




  }





  /*
  Shopify Theme Editor Support
  */


  if(
    document.readyState === "loading"
  ){

    document.addEventListener(
      "DOMContentLoaded",
      initRegionSelector
    );


  }else{

    initRegionSelector();

  }



})();